import React from 'react';
import css from './BecomeCreatorPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import ProfileSection from './sections/ProfileSection/ProfileSection';
import WhySection from './sections/WhySection/WhySection';
import TermsSection from './sections/TermsSection/TermsSection';
import JoinSection from './sections/JoinSection/JoinSection';
import LiveScansSection from '../CustomLandingPage/sections/LiveScansSection/LiveScansSection';

const BecomeCreatorPage = (props) => {
  return (
    <Page title={'ScanWow'} description={'ScanWow'} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <ProfileSection />
        <WhySection />
        <LiveScansSection />
        <TermsSection />
        <JoinSection />
      </LayoutSingleColumn>
    </Page>
  );
};

export default BecomeCreatorPage;
